export default {
  title: 'Thank you for submitting your information to receive payments',
  description:
    'The review from Stripe might take up to 48 hours. Meanwhile, you can continue with the next steps. We will inform you via email as soon your information is confirmed.',
};
